import { JsonObject } from 'json2typescript';
import { GenericMessageResponseInterface } from '../interfaces/generic-message.interface';

@JsonObject('GenericMessageResponseModel')
export class GenericMessageResponseModel implements GenericMessageResponseInterface {
  Message: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
